<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'skew-y',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Skew Y',
            defaultUnit: 'deg',
            message: '* skew units are measured in degrees',
            tailwindDefinitionProp: 'skew',
        };
    },
};
</script>
